const swiperRacingSeason = {
    swiperInstance: null,
    init: () => {
        import("swiper/bundle").then(({ Swiper }) => {
            let domEls = document.querySelectorAll(".js-swiper-racing-season");
            if (domEls) {
                const params = getSwiperParams();
                domEls.forEach((el) => {
                    swiperRacingSeason.swiperInstance = new Swiper(el, params);
                });
            }
        });
    },
};

const getSwiperParams = () => {
    return {
        watchOverflow: true,
        centeredSlides: false,
        spaceBetween: 14,
        slidesPerView: 2,
        slideToClickedSlide: true,
        resizeObserver: true,
        a11y: true,
        mousewheel: {
            forceToAxis: true,
        },
        grabCursor: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            type: "progressbar",
        },
        breakpoints: {
            768: {
                slidesPerView: 5,
                spaceBetween: 14,
            },
            1024: {
                slidesPerView: 7,
                spaceBetween: 8,
            },
            1360: {
                slidesPerView: 11,
                spaceBetween: 8,
            },
        },
    };
};

export default swiperRacingSeason;
